import React from "react"
import styled from "styled-components"
import { ButtonLink } from "styleguide/components/Button"
import { P } from "styleguide/components/Text"
import { uiColorToBaseColor } from "styleguide/styles/colors"
import { fontFamily } from "styleguide/styles/fonts"
import media from "styleguide/styles/media-queries"
import Container from "./grid/Container"

const BlackFullWidthContainer = styled.div`
  background-color: ${uiColorToBaseColor("black")};
`

const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 320px;

  ${media.tablet`
    min-height: 352px;
  `}
`

const StyledHeader = styled(P)`
  color: #ffffff;
  font-weight: 800;
  max-width: 928px;
  text-align: center;
  margin-bottom: 16px;
  font-family: ${fontFamily("heading")};
`

const StyledLink = styled.a`
  color: ${uiColorToBaseColor("red")};
  text-decoration: underline;
  font-weight: 800;
  cursor: pointer;

  ${media.tablet`
    display: block;
  `}
`

const StyledButton = styled(ButtonLink)`
  font-size: 16px;
  font-family: ${fontFamily("base")};
  font-weight: 600;
  padding-top: 12px;
  padding-bottom: 12px;
`

const EmailUs = () => (
  <BlackFullWidthContainer>
    <StyledContainer>
      <StyledHeader size="XXL">
        Email us at&nbsp;
        <StyledLink href="mailto:contact@shakacode.com">
          contact@shakacode.com
        </StyledLink>
        &nbsp;for more information <br /> or
      </StyledHeader>
      <StyledButton
        href="https://meetings.hubspot.com/justingordon/30-minute-consultation"
        target="_blank"
      >
        Book a free call
      </StyledButton>
    </StyledContainer>
  </BlackFullWidthContainer>
)

export default EmailUs
